import { render, staticRenderFns } from "./sellMaterialTask.vue?vue&type=template&id=2ff3e538&scoped=true"
import script from "./sellMaterialTask.vue?vue&type=script&lang=js"
export * from "./sellMaterialTask.vue?vue&type=script&lang=js"
import style0 from "./sellMaterialTask.vue?vue&type=style&index=0&id=2ff3e538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3e538",
  null
  
)

export default component.exports